import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import styled from "styled-components";
import EditIcon from "../editicon.png";
import { CloseO } from "styled-icons/evil/CloseO";
import AddShift from "./AddShift";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { withRouter } from "react-router-dom";
import { deleteManagerShift } from "../../../../Actions";

class Shift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDataOpen: false,
      shiftData: [],
      shiftEditData: undefined,
      heightSet: 0,
    };
    this.openForm = this.openForm.bind(this);
    this.cancelForm = this.cancelForm.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    if (this.props.shiftData !== void 0)
      this.state.shiftData.length === 0 &&
        this.setState({ shiftData: this.props.shiftData });
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight });
  }
  openEditForm = (data) => {
    this.setState((state) => ({
      formDataOpen: data.shiftIdtrue !== "1" ? true : false,
      shiftEditData: data,
    }));
    this.updateShiftDetails();
  };
  openForm(data) {
    this.setState((state) => ({
      formDataOpen: true,
      shiftEditData: undefined,
    }));
  }
  cancelForm() {
    this.setState((state) => ({
      formDataOpen: false,
    }));
  }
  updateShiftDetails = security => {
    return (
      <AddShift onClose={this.cancelForm} data={this.state.shiftEditData} security={security} />
    );
  };
  componentDidUpdate(nextProps) {
    if (this.props !== nextProps) {
      this.setState({ shiftData: this.props.shiftData });
      this.updateDimensions();
    }
  }
  deleteShift = (data) => {
    data.maintainenceUser = this.props.ssoId;
    this.props.dispatch(deleteManagerShift(data));
  };
  render() {
    const { formDataOpen } = this.state;
    const { security } = this.props
    var updatedHt = this.state.heightSet - 278;
    const empDivStyle = {
      maxHeight: updatedHt + "px",
    };
    return this.props.shiftData ? (
      <MainApp>
        <ContainerDiv>
          <HeaderDiv>
            <ROW>
              <ColFirst lg="2">
                <Trans>shiftPlan</Trans>
              </ColFirst>
              <Col lg="1">
                <Trans>start</Trans>
              </Col>
              <Col lg="1">
                <Trans>finish</Trans>
              </Col>
              <Col lg="2">
                <Trans>paidBreaks</Trans>
              </Col>
              <Col lg="2">
                {this.props.security.enableBreaksCal === "Y" ? (
                  <Trans>unpaidBreak</Trans>
                ) : (
                    <Trans>unpaidBreaks</Trans>
                  )}
              </Col>
              {/* <Col lg="1">Premium</Col> */}
              <Col lg="2">
                <Trans>shiftAllowance</Trans>
              </Col>
              <Col lg="1">
                <Trans>edit</Trans>
              </Col>
              <Col lg="1">
                <Trans>remove</Trans>
              </Col>
            </ROW>
          </HeaderDiv>
          <ContentDiv style={empDivStyle}>
            {this.state.shiftData.map((shiftData, index) => (
              <ROW key={index}>
                <ColFirst lg="2">{shiftData.shiftPlan}</ColFirst>
                <Col lg="1">{shiftData.shiftStartTime}</Col>
                <Col lg="1">{shiftData.shiftEndTime}</Col>
                <Col lg="2">
                  {shiftData.paidBreakTime} <Trans>mins</Trans>
                </Col>
                <Col lg="2">
                  {shiftData.unPaidBreakTime} <Trans>mins</Trans>
                </Col>
                <Col lg="2">
                  {shiftData.shiftAllowance === "Y" && <div>Yes</div>}
                  {shiftData.shiftAllowance === "N" && <div>No</div>}
                </Col>
                <Col lg="1">
                  {shiftData.shiftId !== "2" && (
                    <ImageDiv
                      onClick={() => {
                        this.openEditForm(shiftData);
                      }}
                    >
                      <Img src={EditIcon} alt="edit" />
                    </ImageDiv>
                  )}
                </Col>
                <Col lg="1">
                  {shiftData.shiftId !== "1" && shiftData.shiftId !== "2" && (
                    <CloseO
                      onClick={() => this.deleteShift(shiftData)}
                      size="20"
                    />
                  )}
                </Col>
              </ROW>
            ))}
          </ContentDiv>
        </ContainerDiv>

        <FooterData formDataOpen={formDataOpen} heightData={updatedHt}>
          {!formDataOpen ? (
            <p>
              <Btn onClick={this.props.BackTab}>
                <Trans>back</Trans>
              </Btn>
              <Btn onClick={this.openForm}>
                <Trans>create</Trans>
              </Btn>
            </p>
          ) : (
              this.updateShiftDetails(security)
            )}
        </FooterData>
      </MainApp>
    ) : (
        <div />
      );
  }
}

const MainApp = styled.div`
  position: relative;
  height: 100vh;

`;
const ContainerDiv = styled(Container)`
  width: 100%;
  float: center;
  font-family: Trebuchet MS;
  padding-top: 1%;
`;
const ColFirst = styled(Col)`
  text-align: left;
  padding-left: 20px;
`;
const ROW = styled(Row)`
  display: flex;
  flex-wrap: unset !important;
  margin-right: -15px;
  margin-left: -15px;
  padding: 0px 15px 0px 0px;
`;
const HeaderDiv = styled.div`
  background: grey;
  min-height: 30px;
  height: auto;
  background: #f1f4f9;
  font-weight: bold;
  font-size: 14px;
  border-radius: 4px;
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 10px;
`;
const ContentDiv = styled.div`
  font-size: 16px;
  padding-left: 11px;
  padding-top: 4px;
  padding-right: 10px;
  line-height: 30px;
  overflow-y: auto;
  overflow-x: hidden;
`;
const Img = styled.img`
  height: 15px;
  width: 15px;
`;
const ImageDiv = styled.div``;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  text-align: center;
  position:fixed
  bottom:0px
  right: 0px;
  width: 101%;
  margin-left: 4px;
  && p {
    bottom: 0px;
    position: absolute;
    width: 100%;
  }
  ${({ formDataOpen, heightData }) =>
    formDataOpen &&
    `position:absolute
      height: 230px
      bottom:${170}px
  `}
`;
const Btn = styled.button`
  background: #fff;
  border-radius: 30px;
  margin: 0 5px;
  padding: 0;
  border: 1px solid #babec3;
  height: 38px;
  width: 129px;
  font-weight: 50;
  position: relative;
  left: 8px;
  color: #000;
  font-size: 12px;
`;
const mapStateToProps = ({ auth, userMessage, managerTimesheetData, fetchTimesheetSecurity }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    shiftData: managerTimesheetData.payload.shiftList,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(Shift)));
